
import gql from 'graphql-tag';

const DELETE_PROSPECT_FOLLOW_UP = gql` 
  mutation deleteProspectFollowUp($input: ProspectFollowUpDeleteInput!) {
    deleteProspectFollowUp(input: $input) {
      message
      code
    }
  }
`;

export default DELETE_PROSPECT_FOLLOW_UP;